<ion-app>
  <ion-split-pane
    contentId="main"
    class="background-background"
    [class.settings]="isSettingsPage"
    [when]="isSettingsPage ? desktopSettingsMenuBreakpoint : desktopMenuBreakpoint"
  >
    <ion-menu
      #menu
      contentId="main"
      [swipeGesture]="false"
      (ionWillClose)="settingsPaneOpen = false"
      (ionWillOpen)="settingsPaneOpen = true"
    >
      <ion-header>
        <ion-toolbar class="thin-toolbar background-background" mode="ios">
          <div
            class="layout-header border-border"
            [class.desktop]="showDesktopMenu"
            [class.bottom]="!showDesktopMenu && settingsPaneOpen && isSettingsPage"
          >
            <div
              class="first-row border-border"
              [class.mobile]="!showDesktopMenu"
            >
              <span
                class="logo user-select-none"
                [class.centered]="!showDesktopMenu"
                (click)="goRoot()"
              >
                <img
                  *ngIf="path"
                  class="user-select-none"
                  src="assets/img/{{path}}/logo.png"
                  alt="{{path | titlecase}} logo"
                >
              </span>

              <tablesready-theme-switcher
                *ngIf="!showDesktopMenu"
                toggleId="mobile-switcher"
              ></tablesready-theme-switcher>

              <div
                *ngIf="isSettingsPage && showDesktopMenu"
                class="settings-title border-border"
              >
                <p>settings</p>
              </div>
            </div>

            <div class="second-row">
              <tablesready-location-switcher
                *ngIf="!showDesktopMenu"
                popoverSide="right"
                [width]="'16.9rem'"
                [id]="'mobile-theme-switch'"
              ></tablesready-location-switcher>

              <div
                *ngIf="!showDesktopMenu && settingsPaneOpen && isSettingsPage"
                class="back-button"
              >
                <ion-button (click)="settingsPaneOpen = false" fill="clear">
                  <tr-icon class="icon ml-2" [size]="iconSize.small" [icon]="icon.arrowBack"></tr-icon>
                  <p class="ml-2">Main Menu</p>
                </ion-button>
              </div>
            </div>
          </div>
        </ion-toolbar>
      </ion-header>

      <ion-content [forceOverscroll]="false">
        <div class="sidebar-wrapper" #sidebarRef>
          <tr-sidebar
            *ngIf="(isSettingsPage && !showDesktopMenu && !settingsPaneOpen) || (isSettingsPage && showDesktopMenu) || (!isSettingsPage)"
            [compact]="!showDesktopMenu"
            [items]="navItems"
            [path]="path"
            [user]="user"
            (logout)="onLogout(); menu.close(false);"
            (itemClick)="sidebarItemClick($event, menu)"
            [class.no-border]="!showDesktopMenu"
            [class.tr-sidebar]="showDesktopMenu"
            class="border-border"
          ></tr-sidebar>

          <div
            *ngIf="(!showDesktopMenu && isSettingsPage && settingsPaneOpen) || showDesktopMenu"
            [ngClass]="isSettingsPage && settingsPaneOpen ? 'overflow-y-auto' : 'overflow-y-hidden'"
            class="settings-nav"
          >
            <frontend-settings-nav (itemClicked)="menu.close(true);"></frontend-settings-nav>
          </div>
        </div>
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main" [animated]="false"></ion-router-outlet>
  </ion-split-pane>

  <lib-frontend-chat-party-modal></lib-frontend-chat-party-modal>

  <tablesready-notification-center-sidebar
    (messageClicked)="onMessageClicked($event)"
  >
  </tablesready-notification-center-sidebar>
</ion-app>
